import { toDriveDirectUrl } from "@/lib/utils";

export interface Cita {
  id: number;
  texto: string;
  autor?: string;
  cargo?: string;
  sector?: string;
  fecha?: string;
  likes?: number;
  avatar?: string;
}

export interface QuoteCardVerticalProps {
  cita?: Cita;
}

export default function QuoteCardVertical({ cita }: QuoteCardVerticalProps) {
  if (!cita) {
    return (
      <div className="bg-white rounded-2xl border border-masmed-gray-200 shadow-sm p-5 md:p-6 flex flex-col items-center text-center min-h-[200px] justify-center">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-masmed-gray-100 flex-shrink-0" />
        <div className="w-24 h-4 bg-masmed-gray-100 rounded mt-3" />
        <div className="w-16 h-3 bg-masmed-gray-100 rounded mt-1" />
        <div className="w-12 h-0.5 bg-masmed-gray-100 rounded-full mt-3" />
        <div className="w-full h-12 bg-masmed-gray-100 rounded mt-3" />
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-masmed-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200 p-5 md:p-6 flex flex-col items-center text-center">
      {/* Avatar circular con borde naranjo */}
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-primary p-0.5 flex-shrink-0">
        <img
          src={toDriveDirectUrl(cita.avatar || "")}
          alt={cita.autor}
          className="w-full h-full rounded-full object-cover"
        />
      </div>

      {/* Nombre */}
      <p className="text-masmed-gray-900 text-sm md:text-base mt-3 md:mt-4"
      style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 700 }}>
        {cita.autor}
      </p>

      {/* Fecha */}
      <p className="text-masmed-gray-400 text-xs mt-0.5">
        {cita.fecha}
      </p>

      {/* Línea naranja */}
      <div className="w-12 h-0.5 bg-primary rounded-full mt-3 md:mt-4" />

      {/* Cita */}
      <p className="text-masmed-gray-600 text-sm leading-relaxed mt-3 md:mt-4">
        {cita.texto}
      </p>
    </div>
  );
}